module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5zhhv"))).then(() => parcelRequire('hEqeo'));